import { useEffect, useState, useRef } from 'react';
import { SearchBox } from '@mapbox/search-js-react';
import { Box, Button } from 'src/components';
import MapPickerModal from './location-map-picker-modal'; 

const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;

const AMERICAS_AND_ANTARCTICA = [
  'US','CA','MX','GT','HN','NI','CR','PA','CU','DO','HT','JM','BS','BZ',
  'CO','VE','EC','PE','BO','CL','AR','UY','PY','BR','SR','GY','GF',
  'FK','AQ' 
];

export default function LocationAutocomplete({ value, currentCoords, onSelect }) {
    const [inputValue, setInputValue] = useState(value || '');
    const [modalOpen, setModalOpen] = useState(false);

    const ref = useRef();

    const handleMapPick = ({ label, coords, countryCode }) => {
        setInputValue(label);
        onSelect({
            label,
            coords,
            countryCode: countryCode,
        });
        setModalOpen(false);
    };

    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    useEffect(() => {
        if (ref.current) {
            ref.current.focus();
        }
    }, []);

    return (
        <>
            <SearchBox
                ref={ref}
                accessToken={MAPBOX_TOKEN}
                value={inputValue}
                onChange={(val) => setInputValue(val)}
                onRetrieve={(result) => {
                    if (result?.features?.[0]) {
                        const f = result.features[0];
                        const newCoords = {
                            lat: f.geometry.coordinates[1],
                            lng: f.geometry.coordinates[0],
                        };
                        onSelect({
                            label: f.properties.full_address || f.properties.name,
                            coords: newCoords,
                            countryCode: f.properties.context?.country?.country_code?.toUpperCase() || null,
                        });
                        setInputValue(f.properties.full_address || f.properties.name);
                    }
                }}
                onClear={() => {
                    onSelect(null);
                    setInputValue('');
                }}
                placeholder="e.g. Buenos Aires, Argentina"
                options={{
                    language: 'en',
                    limit: 7,
                    types: ['country', 'region', 'district', 'place', 'locality', 'neighborhood', 'street'],
                    country: AMERICAS_AND_ANTARCTICA.join(','),
                }}
                popoverOptions={{
                    placement: 'bottom-start',
                    flip: true
                }}
            />

            <Box sx={{ mt: 1, textAlign: 'center' }}>
                <Button 
                    size="small" 
                    variant="text" 
                    onClick={() => setModalOpen(true)}
                >
                    Not found? Pick on map
                </Button>
            </Box>

            <MapPickerModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                onConfirm={handleMapPick}
                initialCoords={currentCoords} 
            />
        </>
    );
}